"use client"

import clsx from "clsx"
import { ReactNode } from "react"

export type NpSeriesCardButtonProps = {
  onClick: () => void
  available: boolean
  active: boolean
  className?: string
  children: ReactNode
}

export const NpSeriesCardButton = ({ onClick, available, active, className, children }: NpSeriesCardButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(className, "w-full rounded-2xl border", {
        "hover:border-np-green": available,
        "hover:border-np-red": !available,
        "bg-np-green10 border-np-green25": active && available,
        "bg-np-red10 border-np-red25": active && !available,
      })}
    >
      {children}
    </button>
  )
}
